import _extends from "@babel/runtime/helpers/extends";
/*
 *                     NOTICE
 *            COPYRIGHT 2019 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { convertButtonProps } from "abreact/misc/AbButton";
import { AbDialog as AbDialogImpl } from "abreact/popup/AbDialog";
import * as React from "react";

/**
 * Properties of the AbDialog component.
 */

/**
 * The **AbDialog** component is a modal popup dialog for conducting a user interaction.
 *
 * [[include:absdk/commons/ui/popup/AbDialog.md]]
 */
export class AbDialog extends React.Component {
  render() {
    return /*#__PURE__*/React.createElement(AbDialogImpl, _extends({}, this.props, {
      cancelButtonProps: convertButtonProps(this.props.cancelButtonProps),
      okButtonProps: convertButtonProps(this.props.okButtonProps)
    }));
  }
}
//# sourceMappingURL=AbDialog.js.map
